import type { MouseEventHandler } from "react";

import { cn } from "../../utils";
import Button from "../button/Button";
import { XIcon } from "../icons";
import ClosePrimitive from "./Close";

export interface DialogXCloseProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const XClose = ({ className, onClick, disabled = false }: DialogXCloseProps) => {
  return (
    <ClosePrimitive tabIndex={-1} className={cn("absolute top-3 right-5", className)} asChild>
      <Button icon size="xs" disabled={disabled} color="secondary" variant="ghost" onClick={onClick}>
        <XIcon className="h-5 w-5" />
      </Button>
    </ClosePrimitive>
  );
};

export default XClose;
